/* eslint-disable import/no-anonymous-default-export */
export default {
  changeTimezone: "تغيير  المنطقة الزمنية",
  save: "حفظ",
  cancel: "الغاء",
  timeZoneLabel: "إختر المنطقة الزمنية",
  timeZoneError: "الرجاء تحديد المنطقة الزمنية",
};
